<template>
  <div class="scrollable">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Scrollable',
};
</script>

<style lang="scss" scoped>
.scrollable > * {
  overflow: hidden;
}
.scrollable > *:hover {
  overflow: overlay;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, rgba(#EFEFEF, 0.2)) var(--scrollbar-bg, #1a1c1d);
}
::-webkit-scrollbar {
    width: 3px;
}
::-webkit-scrollbar-track  {
    background: var(--scrollbar-bg, #1a1c1d);
}
::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(#EFEFEF, 0.2));
  border-radius: 3px;
}
@-moz-document url-prefix() {
  .scrollable > *:hover {
    overflow: auto;
  }
}
</style>
